import React, { useEffect } from "react";
import PrintExport from "../../../components/common/ui/Export/PrintExport";
import { history } from "../../../_helpers";
import Button from "../../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { staffRequestAction } from "../../../_store";
// import { handleReviewFormNavigation } from "./ReviewRequestFormNavigator";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import { handleReviewMessageToInmateNavigator } from "./ReviewMessageToInmateNavigator";

function MessageToInmateFormHeader({
  handlePrints,
  list,
  showFeedBack,
  handleFeedBack,
  source,
  navigateBack,
  errorMessage,
  setErrorMessage,
  requestFormSubmitted,
  setRequestFormSubmitted,
}) {
  const dispatch = useDispatch();

  const {
    requestReview,
    messageToInmateSearchListData,
    initiateInmateMessageList,
    indexValue,
  } = useSelector((x) => x?.staffRequest);
  const { user } = useSelector((x) => x.auth);
  const managementUserID = user?.ManagementUserID;

  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);

  useEffect(() => {
    if (
      !requestReview &&
      list?.DataList?.length > 0
      // source === "MessageToInmate"
    ) {
      history?.navigate("/Admin/StaffRequestList/MessageToInmate");
    }
  }, [requestReview]);

  const handlePrevNext = (direction) => {
    //clear error message when navigate
    setErrorMessage({});
    //clear form value
    dispatch(staffRequestAction?.resetMessageToInmateRequestFormPayloadData());
    // if (direction === "next" && list?.DataList?.length === indexValue + 1)
    //   return;

    // if (direction === "prev" && indexValue === 0) return;

    // const index = indexValue;
    // dispatch(staffRequestAction?.updateReviewStatus(true));
    // var updateIndex = direction === "next" ? index + 1 : index - 1;

    // if (!requestReview) return;
    // dispatch(staffRequestAction?.updateIndexValue(updateIndex));
    // const row = list?.DataList[updateIndex];

    if (
      requestFormSubmitted !== undefined &&
      requestFormSubmitted !== null &&
      requestFormSubmitted === true &&
      requestReview
    ) {
      const searchData = { ...messageToInmateSearchListData };
      searchData.facilityID = facilityCode;
      searchData.ActiveStatus =
        searchData.ActiveStatus === 3 ? 2 : searchData.ActiveStatus;
      searchData.ManagementUserID = managementUserID;
      searchData.PageNo = 1;
      // searchData.RowCountPerPage = 10;
      searchData.RowCountPerPage = initiateInmateMessageList?.TotalRecordCount;
      dispatch(staffRequestAction?.LoadMGUserRequestReviewDataList(searchData))
        .then((result) => {
          if (result?.payload) {
            const data = result?.payload;
            handleReviewMessageToInmateNavigator(
              direction,
              data,
              direction === "next" ? indexValue : indexValue == 0 ? indexValue : indexValue - 1,
              history,
              "MessageToInmate",
              dispatch
            );
          }
        })
        .catch((err) => {
          showToastNotification("Something went wrong", "error");
        });

      setRequestFormSubmitted(false);
      return;
    }
    const index = indexValue;
    dispatch(staffRequestAction?.updateReviewStatus(true));
    if (!requestReview) return;
    var updateIndex = direction === "next" ? index + 1 : index - 1;
    if (direction === "prev" && indexValue === 0) {
      updateIndex = list?.DataList?.length - 1;
    }
    if (direction === "next" && list?.DataList?.length === indexValue + 1) {
      updateIndex = 0;
    }
    dispatch(staffRequestAction?.updateIndexValue(updateIndex));
    const row = list?.DataList[updateIndex];
    history.navigate("StaffRequestList/MessageToInmateRequestForm", {
      state: {
        RequestForumMGUserThreadID: row?.RequestForumMGUserThreadID,
        formID: row?.RequestFormTypeID,
        RequestFormType: row?.RequestFormType,
        RequestFormTypeID: row?.RequestFormTypeID,
        InmateID: row?.InmateID,
        InmateResidentId: row?.InmateResidentId,
        formDetails: list,
        sourceFrom: "MessageToInmate",
      },
    });
  };

  return (
    <div className="d-flex flex-wrap justify-content-end gap-3">
      {requestReview &&
        (indexValue !== 0 || list?.DataList?.length !== indexValue + 1) && (
          <div className=" d-flex flex-wrap justify-content-center align-items-center gap-3">
            <i
              className={`fas fa-arrow-alt-circle-left fs-2 cursor-pointer ${indexValue === 0 ? "" : ""
                }`}
              onClick={() => handlePrevNext("prev")}
              title="prev"
            ></i>

            <i
              className={`fas fa-arrow-alt-circle-right fs-2 cursor-pointer ${list?.DataList?.length === indexValue + 1 ? "" : ""
                }`}
              onClick={() => handlePrevNext("next")}
              title="next"
            />
          </div>
        )}
      <PrintExport
        handlePrintShow={() => {
          handlePrints();
        }}
      />
      {showFeedBack && (
        <div
          data-bs-toggle="modal"
          data-bs-target="#public-defender-crisp-feedback"
        // onClick={() => handlePCRCount(row)}
        >
          <Button
            label="Feedback"
            type="button"
            status="success"
            onClick={() => handleFeedBack()}
          />
        </div>
      )}
      <Button
        label="Back"
        type="button"
        icon={"fa-solid fa-angle-left"}
        status="primary"
        onClick={() => {
          dispatch(staffRequestAction?.updateReviewStatus(false));
          history?.navigate(
            navigateBack ? navigateBack : "/Admin/StaffRequestList"
          );
          // dispatch(staffRequestAction?.resetMessageToInmateSearchList());
        }}
      />
    </div>
  );
}

export default React.memo(MessageToInmateFormHeader);
